import { TENANT_PLATFORM } from '@hiver/bifrost-js';
import { ReactComponent as GmailIcon }  from "../../images/GmailIcon.svg";
import { ReactComponent as OutlookIcon} from "../../images/OutlookIcon.svg";

export const EMAIL_PLACEHOLDER = 'Enter your Hiver email';
export const LOG_IN_DESCRIPTION = 'Log in to access your Knowledge base';
export const LOG_IN = 'Log In';
export const WELCOME = 'Welcome!';
export const DIFF_EMAIL_ERROR = 'Please login using the same Google account';
export const NO_ACCESS_ERROR = 'You don’t have access to this section, please contact your administrator';
export const DEFAULT_LOGO = 'default';
export const LOGO_IMG = 'https://app.hiverkb.com/{{LOGO}}';
export const selectEmailProviderText = 'Select your email provider';
export const gmail = 'Gmail';
export const outlook = 'Outlook';
export const emailLabel = 'Enter your email address';

export const EMAIL_SELECTOR_PROVIDERS = [
    {
        NAME: gmail,
        TENANT_ID: TENANT_PLATFORM.GMAIL,
        ICON: GmailIcon,
        IMG_ALT: gmail
    },
    {
        NAME: outlook,
        TENANT_ID: TENANT_PLATFORM.HIVERWEB,
        ICON: OutlookIcon,
        IMG_ALT: outlook
    }
];
